import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const ConfidentialitePage = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-24" data-testid="confidentialite-page">
      <div className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <nav className="flex items-center gap-2 text-sm">
            <Link to="/" className="text-gray-500 hover:text-orange-600">Accueil</Link>
            <ChevronRight className="w-4 h-4 text-gray-400" />
            <span className="text-orange-600 font-medium">Politique de Confidentialité</span>
          </nav>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Politique de Confidentialité</h1>
        <p className="text-gray-600 mb-8">
          La SAS Barnum Événement & Loisirs, spécialiste de la location de matériel événementiel en Normandie, attache une importance particulière à la protection de vos données personnelles. La présente politique de confidentialité a pour objet de vous informer sur la manière dont nous collectons, utilisons et protégeons vos données, conformément au Règlement Général sur la Protection des Données (RGPD – Règlement UE 2016/679) et à la loi Informatique et Libertés du 6 janvier 1978 modifiée.
        </p>
        
        <div className="bg-white rounded-xl p-8 shadow-sm space-y-10 text-gray-700 leading-relaxed">

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Responsable du traitement</h2>
            <p>Le responsable du traitement des données collectées sur le site barnum-evenement.fr est :</p>
            <ul className="mt-3 space-y-1 ml-4">
              <li><strong>SAS Barnum Événement & Loisirs</strong></li>
              <li>40 rue de la Libération, 76700 Gainneville</li>
              <li>Email : <a href="mailto:contact@barnum-evenement.fr" className="text-orange-500 hover:underline">contact@barnum-evenement.fr</a></li>
              <li>Téléphone : 06 98 43 09 92</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Données personnelles collectées</h2>
            <p>Dans le cadre de l'utilisation du site barnum-evenement.fr et de nos services de location de chapiteaux, barnums, mobilier événementiel et équipements en Normandie, nous sommes amenés à collecter les données personnelles suivantes :</p>
            
            <h3 className="font-semibold text-gray-800 mt-5 mb-2">a) Formulaire de demande de devis</h3>
            <ul className="space-y-1 ml-4 list-disc">
              <li>Nom et prénom</li>
              <li>Adresse email</li>
              <li>Numéro de téléphone</li>
              <li>Type d'événement (mariage, anniversaire, séminaire, festival, etc.)</li>
              <li>Date et lieu de l'événement</li>
              <li>Description des besoins en matériel</li>
            </ul>

            <h3 className="font-semibold text-gray-800 mt-5 mb-2">b) Formulaire de téléchargement du catalogue</h3>
            <ul className="space-y-1 ml-4 list-disc">
              <li>Nom et prénom</li>
              <li>Adresse email</li>
              <li>Numéro de téléphone</li>
              <li>Type d'événement envisagé</li>
            </ul>

            <h3 className="font-semibold text-gray-800 mt-5 mb-2">c) Données de navigation</h3>
            <ul className="space-y-1 ml-4 list-disc">
              <li>Adresse IP</li>
              <li>Type de navigateur et système d'exploitation</li>
              <li>Pages consultées et durée de visite</li>
              <li>Source de trafic (moteur de recherche, lien direct, réseaux sociaux)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Finalités du traitement</h2>
            <p>Les données personnelles collectées sont utilisées pour les finalités suivantes :</p>
            <ul className="mt-3 space-y-2 ml-4 list-disc">
              <li><strong>Gestion des demandes de devis :</strong> répondre à vos demandes de location de matériel événementiel (chapiteaux, barnums, tentes de réception, mobilier, vaisselle, éclairage, sonorisation, structures gonflables, matériel de restauration)</li>
              <li><strong>Envoi du catalogue produits :</strong> vous transmettre notre catalogue 2026 de location de matériel événementiel</li>
              <li><strong>Suivi commercial :</strong> vous recontacter dans le cadre de votre projet événementiel en Normandie</li>
              <li><strong>Amélioration du site :</strong> analyser la fréquentation et optimiser l'expérience utilisateur de barnum-evenement.fr</li>
              <li><strong>Obligations légales :</strong> respecter nos obligations comptables et fiscales</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Base juridique du traitement</h2>
            <p>Le traitement de vos données personnelles repose sur les bases juridiques suivantes :</p>
            <ul className="mt-3 space-y-2 ml-4 list-disc">
              <li><strong>Votre consentement</strong> (article 6.1.a du RGPD) : lorsque vous remplissez un formulaire de contact, de demande de devis ou de téléchargement du catalogue</li>
              <li><strong>L'exécution d'un contrat</strong> (article 6.1.b du RGPD) : dans le cadre de la gestion de vos réservations et contrats de location</li>
              <li><strong>L'intérêt légitime</strong> (article 6.1.f du RGPD) : pour l'amélioration de nos services et la sécurité du site</li>
              <li><strong>Les obligations légales</strong> (article 6.1.c du RGPD) : pour le respect de nos obligations comptables et fiscales</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Durée de conservation des données</h2>
            <p>Vos données personnelles sont conservées pour une durée proportionnée à la finalité pour laquelle elles ont été collectées :</p>
            <ul className="mt-3 space-y-2 ml-4 list-disc">
              <li><strong>Données de prospects :</strong> 3 ans à compter du dernier contact, conformément aux recommandations de la CNIL</li>
              <li><strong>Données de clients :</strong> pendant toute la durée de la relation contractuelle, puis 5 ans à des fins comptables et fiscales</li>
              <li><strong>Données de navigation :</strong> 13 mois maximum (cookies et traceurs)</li>
            </ul>
            <p className="mt-3">Au-delà de ces durées, vos données sont supprimées ou anonymisées de manière irréversible.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Destinataires des données</h2>
            <p>Vos données personnelles sont destinées exclusivement à l'équipe commerciale et administrative de la SAS Barnum Événement & Loisirs.</p>
            <p className="mt-3">Elles ne sont en aucun cas cédées, vendues ou louées à des tiers à des fins commerciales.</p>
            <p className="mt-3">Elles peuvent toutefois être communiquées à des sous-traitants techniques intervenant dans la gestion du site (hébergeur, prestataire d'envoi d'emails) dans le strict respect du RGPD et sous la responsabilité de la SAS Barnum Événement & Loisirs.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Transfert de données hors UE</h2>
            <p>Vos données personnelles sont hébergées au sein de l'Union Européenne. En cas de transfert vers un pays tiers, nous nous assurons que des garanties appropriées sont mises en place (clauses contractuelles types approuvées par la Commission Européenne, décision d'adéquation).</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Cookies et traceurs</h2>
            <p>Le site barnum-evenement.fr peut utiliser des cookies pour :</p>
            <ul className="mt-3 space-y-2 ml-4 list-disc">
              <li><strong>Cookies strictement nécessaires :</strong> assurer le bon fonctionnement du site (navigation, sécurité, sessions)</li>
              <li><strong>Cookies de mesure d'audience :</strong> analyser la fréquentation et les parcours de navigation pour améliorer l'expérience utilisateur</li>
            </ul>
            <p className="mt-4">Vous pouvez à tout moment configurer votre navigateur pour accepter, refuser ou supprimer les cookies. Le refus de cookies peut limiter certaines fonctionnalités du site.</p>
            <p className="mt-3">Pour en savoir plus sur la gestion des cookies :</p>
            <ul className="mt-2 space-y-1 ml-4 list-disc text-sm">
              <li>Chrome : Paramètres &gt; Confidentialité et sécurité &gt; Cookies</li>
              <li>Firefox : Options &gt; Vie privée et sécurité</li>
              <li>Safari : Préférences &gt; Confidentialité</li>
              <li>Edge : Paramètres &gt; Cookies et autorisations de site</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Vos droits</h2>
            <p>Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits suivants sur vos données personnelles :</p>
            <ul className="mt-3 space-y-2 ml-4 list-disc">
              <li><strong>Droit d'accès</strong> (article 15 du RGPD) : obtenir la confirmation que des données vous concernant sont ou ne sont pas traitées, et en obtenir une copie</li>
              <li><strong>Droit de rectification</strong> (article 16 du RGPD) : demander la correction de données inexactes ou incomplètes</li>
              <li><strong>Droit à l'effacement</strong> (article 17 du RGPD) : demander la suppression de vos données dans les conditions prévues par la réglementation</li>
              <li><strong>Droit à la limitation du traitement</strong> (article 18 du RGPD) : demander la suspension temporaire du traitement de vos données</li>
              <li><strong>Droit à la portabilité</strong> (article 20 du RGPD) : recevoir vos données dans un format structuré et couramment utilisé</li>
              <li><strong>Droit d'opposition</strong> (article 21 du RGPD) : vous opposer au traitement de vos données pour des motifs légitimes</li>
              <li><strong>Droit de retirer votre consentement</strong> à tout moment, sans que cela ne remette en cause la licéité du traitement effectué avant le retrait</li>
              <li><strong>Droit de définir des directives</strong> relatives au sort de vos données après votre décès</li>
            </ul>
            <div className="mt-5 p-4 bg-orange-50 rounded-lg border border-orange-100">
              <p className="font-medium text-gray-800">Pour exercer vos droits :</p>
              <p className="mt-2">Adressez votre demande accompagnée d'une copie d'un justificatif d'identité à :</p>
              <ul className="mt-2 space-y-1 ml-4">
                <li><strong>Email :</strong> <a href="mailto:contact@barnum-evenement.fr" className="text-orange-500 hover:underline">contact@barnum-evenement.fr</a></li>
                <li><strong>Courrier :</strong> SAS Barnum Événement & Loisirs – 40 rue de la Libération, 76700 Gainneville</li>
              </ul>
              <p className="mt-2">Nous nous engageons à répondre dans un délai d'un mois à compter de la réception de votre demande.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Sécurité des données</h2>
            <p>La SAS Barnum Événement & Loisirs met en oeuvre des mesures techniques et organisationnelles appropriées pour assurer la sécurité et la confidentialité de vos données personnelles, et notamment pour empêcher qu'elles soient déformées, endommagées ou que des tiers non autorisés y aient accès.</p>
            <p className="mt-3">Ces mesures incluent notamment :</p>
            <ul className="mt-3 space-y-1 ml-4 list-disc">
              <li>Le chiffrement des communications (protocole HTTPS/SSL)</li>
              <li>La restriction des accès aux données aux seules personnes habilitées</li>
              <li>La sauvegarde régulière des données</li>
              <li>La mise à jour régulière des systèmes de sécurité</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">11. Réclamation auprès de la CNIL</h2>
            <p>Si vous estimez que le traitement de vos données personnelles constitue une violation du RGPD, vous avez le droit d'introduire une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) :</p>
            <ul className="mt-3 space-y-1 ml-4">
              <li><strong>CNIL</strong> – 3 Place de Fontenoy, TSA 80715, 75334 Paris Cedex 07</li>
              <li><strong>Site web :</strong> <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:underline">www.cnil.fr</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">12. Modification de la politique de confidentialité</h2>
            <p>La présente politique de confidentialité peut être modifiée à tout moment afin de tenir compte des évolutions légales, réglementaires ou technologiques. La date de dernière mise à jour est indiquée ci-dessous.</p>
            <p className="mt-4 text-sm text-gray-500">Dernière mise à jour : Avril 2026</p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default ConfidentialitePage;
